import React, { memo } from 'react'
import { Path, Circle as _Circle } from 'react-native-svg'

import { IconProps } from '../IconProps'
import { IconBase } from '../IconBase'
import { themed } from '../themed'

const Icon = (props) => {
  const { color = 'black', size = 24, ...otherProps } = props
  return (
    <IconBase
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...otherProps}
    >
      <Path
        d="M10.5306 12.4701C10.6715 12.6109 10.7507 12.802 10.7507 13.0013C10.7507 13.2006 10.6715 13.3917 10.5306 13.5326C10.3898 13.6734 10.1987 13.7526 9.9994 13.7526C9.80014 13.7526 9.60905 13.6734 9.46815 13.5326L4.46815 8.53255C4.39823 8.46287 4.34275 8.38008 4.3049 8.28891C4.26704 8.19775 4.24756 8.10001 4.24756 8.0013C4.24756 7.90259 4.26704 7.80485 4.3049 7.71369C4.34275 7.62252 4.39823 7.53973 4.46815 7.47005L9.46815 2.47005C9.60905 2.32915 9.80014 2.25 9.9994 2.25C10.1987 2.25 10.3898 2.32915 10.5306 2.47005C10.6715 2.61095 10.7507 2.80204 10.7507 3.0013C10.7507 3.20056 10.6715 3.39165 10.5306 3.53255L6.06252 8.00068L10.5306 12.4701Z"
        fill={`${color}`}
      />
    </IconBase>
  )
}

Icon.displayName = 'IconChevronLeft'

export const IconChevronLeft = memo(themed(Icon))
